import {API_URL} from "../../dev";

import "isomorphic-fetch";

class SeatingplanApi {
	async getSeatingplan(uuid) {
		try {
			const fetchedSeatingplanResponse = await fetch(`${API_URL}/v1/seatingplan/${uuid}`);
			const fetchedSeatingplanJson = await fetchedSeatingplanResponse.json();
			if (!fetchedSeatingplanResponse.ok) {
				throw fetchedSeatingplanJson;
			}
			return fetchedSeatingplanJson;
		} catch (e) {
			console.error('error', e);
			throw e;
		}
	}
}

const seatingplanApi = new SeatingplanApi();
export default seatingplanApi;
